import {Injectable} from "@angular/core";
import {MatDialog, MatDialogRef, MatDialogConfig} from "@angular/material/dialog";
import {Observable} from "rxjs";
import {ConfirmComponent} from "../confirm/confirm.component";

@Injectable()
export class ConfirmService {

  private dialogRef: MatDialogRef<ConfirmComponent>;

  constructor(private dialog: MatDialog) { }

  public confirm(title: string, message: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-modalbox';

    this.dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    this.dialogRef.componentInstance.title = title;
    this.dialogRef.componentInstance.message = message;

    return this.dialogRef.afterClosed();

  }
}
